import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV100() {
  return (
    <ReleaseCard version="v1.0.0" date="14th January 2024" title="Initial Release - The Beginning of Something Amazing!">
      <p className="text-gray-300 mb-4">We are thrilled to announce Poppy Poker (v1.0.0) is now available on the App Store and Play Store.</p>
      <p className="text-gray-300 mb-4">Poppy Poker's unique selling point is its simultaneous alert feature for all connected devices, ensuring you never miss a level change. Here's a quick summary of other amazing features available:</p>
      <ul className="text-gray-400 space-y-2 mb-4">
        <li>• <strong>Main game screen synchronisation</strong> - Synchronised critical game data across all devices — no one else can match our capability!</li>
        <li>• <strong>Receive level change alerts simultaneously on all devices - <span className="font-bold text-yellow-400">this is a game changer!</span></strong></li>
        <li>• <strong>Club summary page</strong>
          <ul className="ml-4 mt-1 space-y-1">
            <li>• <strong>Upcoming games</strong></li>
            <li>• <strong>Completed game reports</strong> - Detailed reports of winners</li>
          </ul>
        </li>
        <li>• <strong>Access all reports from the venue summary page</strong></li>
        <li>• <strong>Feedback from registered players</strong></li>
        <li>• <strong>Find nearby games</strong> - Use GPS to locate nearby and upcoming games!</li>
        <li>• <strong>One-click access to critical game info</strong></li>
        <li>• <strong>Filter games by distance</strong></li>
        <li>• <strong>Separate sections for running and upcoming games</strong></li>
        <li>• <strong>User registration</strong> - Quick registration with Apple or Google login</li>
        <li>• <strong>Venue registration</strong> - Enter your zip/postcode for GPS searchable games!</li>
        <li>• <strong>Define your own blind structure</strong> - incorporate breaks to your game!</li>
        <li>• <strong>Three game types:</strong>
          <ul className="ml-4 mt-1 space-y-1">
            <li>• Instant: Start immediately</li>
            <li>• Weekly: Schedule regular games</li>
            <li>• Scheduled: Plan a one-off game</li>
          </ul>
        </li>
      </ul>
      <p className="text-purple-400 font-medium">This is just the beginning! We will keep adding features based on your feedback. Share your requests, and your ideas may be included in future updates!</p>
    </ReleaseCard>
  );
}
